import styled from 'styled-components'

export const Root = styled.h3`
  margin-top: 30px;
  margin-bottom: 20px;
`

export const TextHighlight = styled.span`
  color: ${ (props) => props.theme.colors['aok-gruen'] };
`

export const MobileContent = styled.span`
  @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
    display: none;
  }
`
